const BusinessGoal = [
  {
    id: 1,
    value: 'Just getting started',
    backendValue: "Just getting started"
  },
  { 
    id: 2,
    value: 'Launch a product or service',
    backendValue: 'Launch a product or service'
  },
  {
    id: 3,
    value: 'Hire an employee',
    backendValue: 'Hire an employee'
  },
  {
    id: 4,
    value: 'Find a cofounder',
    backendValue: 'Find a cofounder'
  },
  {
    id: 5,
    value: 'Raise capital',
    backendValue: 'Raise capital'
  },
  {
    id: 6,
    value: 'Sell',
    backendValue: 'Sell'
  },
  {
    id: 7,
    value: 'Bolster marketing efforts',
    backendValue: 'Bolster marketing efforts'
  },
  {
    id: 8,
    value: 'Learn new skills',
    backendValue: 'Learn new skills'
  },
];

export default BusinessGoal;